<template>
  <div class="payment-receipt-info">
    <h2>Payment receipt</h2>
    <div class="payment-items">
      <div>
        <div>Customer ID</div>
        <div class="desc">
          <p>{{ personalInfo.personalInformation.cid }}</p>
        </div>
      </div>
      <div>
        <div>Name on Card</div>
        <div class="desc">
          <p>{{ $store.state.guestLogin.finalizationCart.finalizeCartResponse.transactionCart.cartPayment && $store.state.guestLogin.finalizationCart.finalizeCartResponse.transactionCart.cartPayment.paymentMakerFirstName || '' }}
          {{ $store.state.guestLogin.finalizationCart.finalizeCartResponse.transactionCart.cartPayment && $store.state.guestLogin.finalizationCart.finalizeCartResponse.transactionCart.cartPayment.paymentMakerLastName || '' }} </p>
        </div>
      </div>
      <div>
        <div>Date Paid</div>
        <div class="desc">
          <p>{{ paymentDate || '' }}</p>
        </div>
      </div>
      <div>
        <div>Authorization Number</div>
        <div class="desc">
          <p>{{ $store.state.guestLogin.finalizationCart.finalizeCartResponse.transactionCart.cartPayment && $store.state.guestLogin.finalizationCart.finalizeCartResponse.transactionCart.cartPayment.authorizationNumber || '' }}</p>
        </div>
      </div>
      <div>
        <div>Total Amount Paid</div>
        <div class="desc">
          <p>{{ $store.state.guestLogin.finalizationCart.finalizeCartResponse.transactionCart.cartPayment && toCurrencyNum($store.state.guestLogin.finalizationCart.finalizeCartResponse.transactionCart.cartPayment.totalCartAmount) || toCurrencyNum(0) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { parseISO } from 'date-fns'
import format from 'date-fns/format'
import { mapState, mapGetters } from 'vuex'
import { toCurrency } from '@/utils/helpers'
import * as COMMONS from '../../store/_commons'

export default {
  name: "PaymentReceipt",
  computed: {
    ...mapState([
      // 'resDetails',
      // 'resFeeApplicable',
    ]),
    ...mapGetters({
        personalInfo: COMMONS.GUEST_PERSONAL_INFO,
    }),
    /**
     * Formats payment date in client's local time, i.e. not converting to ET for simplicity.
     * @returns {string|*|string}
     */
    paymentDate() {
      const paid = (this.$store.state.guestLogin.finalizationCart.finalizeCartResponse.transactionCart.cartPayment && this.$store.state.guestLogin.finalizationCart.finalizeCartResponse.transactionCart.cartPayment.paymentDate)
          ? this.$store.state.guestLogin.finalizationCart.finalizeCartResponse.transactionCart.cartPayment.paymentDate
          : undefined;

      // feePaidDate may be returned as either an object (happy path) or a string (on reload)/undefined
      let tmp = paid;
      if (tmp && (typeof tmp === 'string')) {
        tmp = parseISO(paid);
      }

      return tmp ? format(tmp, 'MMMM d, yyyy') : '';
    },
  },
  methods: {
    toCurrencyNum(value) {
        return toCurrency(value);
    },
  }
}
</script>

<style lang="scss" scoped>
.payment-receipt-info {
  margin: 0.5em 0 1.5em;
  .payment-items {
    border-top: 1px solid var(--ri-gray);
    border-bottom: 1px solid var(--ri-gray);
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1em;
    padding: 1em 0;
    margin-top: 1em;
    .desc {
      @extend %font-sans-bold;
    }
  }
  @media print {
    margin: -1em 0 0;
  }
}
.payment-receipt {
  margin: 1rem 0;
  border-bottom: 1px solid gray;

.payment-receipt-title {
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 1rem;
  padding: 1rem 0;
  border-bottom: 1px solid gray;
}
.payment-receipt {
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem 10%;
    margin: 15px 0px 10px 0px;
    width: 60%;
    min-width: 500px;
    .payment-receipt-details {
      width: 200px;
    }
  }
}

@media only screen and (max-width: 512px) {
  .payment-receipt{
    .payment-receipt { 
      min-width: 0px;
    }
  } 
}
</style>
